export default {
  methods: {
      download(e, doc) {
          this.$refs.exportDocumentContext.open(e, doc);
      },
  },
};
